import DocReady from '../modules/_doc-ready';

new DocReady( () => {
    //do work

    const cartExist =  document.querySelector('header .cart-wrapper');
    if(cartExist != undefined) { // check if main header and cart exist (it doesn't exist on some landing pages)
        document.querySelector('body').addEventListener("click", function () {
            document.querySelector('.header').classList.remove('search-active');
        });
        document.querySelector('.custom-overlay').addEventListener("click", function () {
            document.querySelector('body').classList.remove('open-overlay');
        });  

        document.querySelector('.top-bar--right .icon-search').addEventListener("click", function () {
            document.querySelector('.top-bar').classList.add('header-active');
        });
        document.querySelector('.mobile-search .close-search').addEventListener("click", function () {
            document.querySelector('.top-bar').classList.remove('header-active');
        });
        document.querySelector("#mobile-header .mobile_nav").addEventListener("click", function () {
            if (document.body.classList.contains('is-active')) {
                document.body.classList.remove("mobile_nav-open");
            } else {
                document.body.classList.add("mobile_nav-open");
            }
        });
        const optionsMobileFilter = document.querySelector('.options-mobile_filter');
        if(optionsMobileFilter !==undefined && optionsMobileFilter != null){
            optionsMobileFilter.addEventListener("click", function () {
                document.body.classList.add('open-filter');
            });
        }

        const sidebarMobileFilter = document.querySelector('.sidebar-mobile-filter .x-icon');
        if (sidebarMobileFilter != undefined && sidebarMobileFilter != null) {
            sidebarMobileFilter.addEventListener("click", function () {
            document.body.classList.remove('open-filter');
           });
         }

        const optionsMobileSort = document.querySelector('.options-mobile_sort');
        if(optionsMobileSort != undefined && optionsMobileSort != null) {
            document.querySelector('.options-mobile_sort').addEventListener("click", function () {
                document.body.classList.add('open-sort');
            });
        }

        const sidebarMobileIconSort = document.querySelector('.sidebar-mobile-sort .x-icon-sort');
        if(sidebarMobileIconSort != undefined && sidebarMobileIconSort != null) {
            document.querySelector('.sidebar-mobile-sort .x-icon-sort').addEventListener("click", function () {
                document.body.classList.remove('open-sort');
            });
        }
    }//endinf
});
